import { Theme } from '@mui/material';
import { Colors } from '@sweatpals/react-ui-kit';

export const headerNavStyles = (theme: Theme) => ({
	root: {
		display: 'flex',
		flexDirection: 'row',
		alignItems: 'center',
		marginLeft: 'auto',
	},
	list: {
		display: 'flex',
		flexDirection: 'row',
		alignItems: 'center',
		gap: { xs: '20px', lg: '32px' },
		textTransform: 'uppercase',
	},
	link: {
		fontWeight: '400',
		fontSize: '12px',
		fontFamily: 'Integral CF',
		lineHeight: '15px',
		cursor: 'pointer',
		color: '#FFFFFF',
		textDecoration: 'none',

		'&:hover': {
			textDecoration: 'underline',
			textDecorationColor: Colors.orange,
			textDecorationThickness: '2px',
			textUnderlineOffset: '4px',
		},
	},
	separator: {
		width: '0.5px',
		height: '24px',
		backgroundColor: '#FFFFFF59',
	},
	textNowrap: {
		whiteSpace: 'nowrap',
	},
	hostLoginButton: {
		p: '6px 12px',
		background: 'rgba(255, 255, 255, 0.10)',
		fontSize: '12px',

		'&:hover': {
			backgroundColor: '#000000'
		},
	},
	launchEventButton: {
		p: '12px 32px',
		height: '40px',
		fontSize: '13px',
		fontWeight: '600'
	},
	accountWrapper: {
		minWidth: '186px',
		display: 'flex',
		gap: '10px',
		alignItems: 'center',
		cursor: 'pointer',
	},
	accountName: {
		color: Colors.white,
		fontFamily: 'Montserrat',
		fontSize: '14px',
		fontWeight: 600,
		lineHeight: '17px',
		textTransform: 'none',
	}
});
